import { render } from "./AuthForm.vue?vue&type=template&id=30ce0683&scoped=true&ts=true"
import script from "./AuthForm.vue?vue&type=script&lang=ts"
export * from "./AuthForm.vue?vue&type=script&lang=ts"

import "./AuthForm.vue?vue&type=style&index=0&id=30ce0683&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ce0683"]])

export default __exports__